import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { ElementsConsumer } from '@stripe/react-stripe-js';

import PaymentDetails from './PaymentDetails';
import PaymentForm from './PaymentForm';
import ListCoverPhoto from '../../ListCoverPhoto';
import StarRating from '../../StarRating';
import Button from 'react-bootstrap/lib/Button';

import { getFixedValue } from '../../../helpers/currencyConvertion';
import messages from '../../../locale/messages';
import { getCalculationDetails } from '../../../helpers/Pricing/getCalculationDetails';

import bt from '../../commonStyle.css';
import s from './Payment.css';
class Payment extends Component {
  static propTypes = {
    listId: PropTypes.number.isRequired,
    hostId: PropTypes.string.isRequired,
    guestId: PropTypes.string.isRequired,
    guestEmail: PropTypes.string.isRequired,
    hostDisplayName: PropTypes.string.isRequired,
    hostPicture: PropTypes.string,
    isHostPictureMigrated: PropTypes.bool,
    coverPhoto: PropTypes.string,
    listTitle: PropTypes.string.isRequired,
    allowedPersonCapacity: PropTypes.number.isRequired,
    listType: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    houseRules: PropTypes.arrayOf(
      PropTypes.shape({
        listsettings: PropTypes.shape({
          itemName: PropTypes.string.isRequired,
        }),
      })
    ),
    checkIn: PropTypes.object.isRequired,
    checkOut: PropTypes.object.isRequired,
    guests: PropTypes.number.isRequired,
    basePrice: PropTypes.number.isRequired,
    cleaningPrice: PropTypes.number,
    tax: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    weeklyDiscount: PropTypes.number,
    monthlyDiscount: PropTypes.number,
    customDiscounts: PropTypes.string,
    extraGuestThreshold: PropTypes.number,
    extraGuestFee: PropTypes.number,
    weekendPrice: PropTypes.number,
    cautionDeposit: PropTypes.number,
    listPhotos: PropTypes.array,
    serviceFees: PropTypes.shape({
      guest: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
      }).isRequired,
      host: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    base: PropTypes.string.isRequired,
    rates: PropTypes.object.isRequired,
    bookingType: PropTypes.string.isRequired,
    policyName: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
    additionalRules: PropTypes.string,
    paymentLoading: PropTypes.bool,
    maximumStay: PropTypes.bool,
    submitting: PropTypes.bool,
    syncErrors: PropTypes.object,
  };

  render() {
    const { guestEmail, hostDisplayName, hostProfileId, isPreApprove, hostPicture, coverPhoto, listPhotos, bookingType, policyName, policyContent, additionalRules, isHostPictureMigrated } = this.props;
    const { listId, listTitle, listType, city, state, country, allowedPersonCapacity, houseRules, hostId, guestId } = this.props;
    const { guests, checkIn, checkOut, guestPicture, threadId, tax } = this.props;
    const { serviceFees, base, rates, specialPricing, bookingData, stripePayment, currency, paymentLoading, maximumStay, submitting, syncErrors } = this.props;
    let { basePrice, cleaningPrice, monthlyDiscount, weeklyDiscount, toCurrency } = this.props;
    let { customDiscounts = null, extraGuestThreshold = 0, extraGuestFee = 0, cautionDeposit = 0, weekendPrice = 0 } = this.props;
    const { formatMessage } = this.props.intl;
    let starRatingValue = 0, isHostServiceEligible, checkInStart, checkInEnd;
    const { taxes, isSpecialPriceAssigned, guestServiceFee, hostServiceFee, bookingSpecialPricing,
      priceForDays, isAverage, total, discount, dayDifference, discountType,
      guestServiceFeeType, hostServiceFeeType, guestServiceFeeValue, hostServiceFeeValue, totalIncludeTax, extraGuestFeeAmount, extraGuestCount
    } = getCalculationDetails({
      startDate: checkIn, basePrice, cleaningPrice, monthlyDiscount, weeklyDiscount, customDiscounts, formatMessage,
      serviceFees, specialPricing, toCurrency, tax, currency, endDate: checkOut, base, rates, extraGuestThreshold, extraGuestFee, weekendPrice, guests
    });

    checkInStart = bookingData?.listingData?.checkInStart;
    checkInEnd = bookingData?.listingData?.checkInEnd;
    isHostServiceEligible = hostServiceFee > priceForDays ? true : false;

    if (bookingData.reviewsCount > 0 && bookingData.reviewsStarRating > 0) {
      starRatingValue = Math.round(bookingData.reviewsStarRating / bookingData.reviewsCount);
    }
    const initialValues = {
      listId,
      listTitle,
      hostId,
      guestId,
      guests,
      checkIn,
      checkOut,
      bookingType,
      paymentType: stripePayment ? "2" : "1",
      guestEmail,
      currency,
      basePrice: getFixedValue(basePrice),
      cleaningPrice: getFixedValue(cleaningPrice),
      taxPrice: getFixedValue(taxes),
      discount: getFixedValue(discount),
      discountType,
      guestServiceFee: getFixedValue(guestServiceFee),
      hostServiceFee: getFixedValue(hostServiceFee),
      total: getFixedValue(total),
      priceForDays: getFixedValue(priceForDays),
      totalValue: getFixedValue(total),
      isSpecialPriceAssigned,
      bookingSpecialPricing: JSON.stringify(bookingSpecialPricing),
      isSpecialPriceAverage: getFixedValue(isAverage),
      dayDifference,
      taxRate: 0,
      checkInStart,
      checkInEnd,
      hostServiceFeeType,
      hostServiceFeeValue,
      guestServiceFeeType,
      guestServiceFeeValue,
      extraGuestFeeAmount: getFixedValue(extraGuestFeeAmount),
      extraGuestCount,
      extraGuestFee: getFixedValue(extraGuestFee),
      cautionDeposit: getFixedValue(cautionDeposit),
      threadId,
      isHostServiceEligible
    };

    return (
      <>
        <Row>
          <Col lg={7} md={7}>
            <ElementsConsumer>
              {({ stripe, elements }) => (
                <PaymentForm
                  hostDisplayName={hostDisplayName}
                  isHostPictureMigrated={isHostPictureMigrated}
                  houseRules={houseRules}
                  allowedPersonCapacity={allowedPersonCapacity}
                  initialValues={initialValues}
                  listId={listId}
                  guestPicture={guestPicture}
                  hostPicture={hostPicture}
                  hostProfileId={hostProfileId}
                  isPreApprove={isPreApprove}
                  stripe={stripe}
                  elements={elements}
                  additionalRules={additionalRules}
                />
              )}
            </ElementsConsumer>
          </Col>
          <Col lg={5} md={5} className={s.positionSticky}>
            <div className={cx(s.summaryCard, s.colCenter)}>
              <div className={s.postionRelative}>
                <div className={s.secondSection}>
                  <div
                    className={cx(
                      s.displayInline,
                      s.avatarWidth,
                      s.vtrMiddle,
                      "avatarWidthPaymentRTL",
                      s.vtrTopSm
                    )}
                  >
                    <ListCoverPhoto
                      className={cx(s.bannerImage, s.backgroundCover)}
                      coverPhoto={coverPhoto}
                      listPhotos={listPhotos}
                      photoType={"x_medium"}
                      bgImage
                    />
                  </div>
                  <div
                    className={cx(s.displayInline, s.contentWidth, s.vtrMiddle)}
                  >
                    {starRatingValue > 0 && (
                      <div className={cx(s.reviewFlex, 'flexWrapElement')}>
                        <div className='reviewStarAlign'>
                          <StarRating className='bigStarRatingAdjust' name={"review"} value={starRatingValue} />
                          <span>{starRatingValue}</span>
                        </div>
                        <span className={s.dotsCss}>&#8226;</span>
                        <span>
                          {bookingData?.reviewsCount}{" "}
                          {bookingData?.reviewsCount > 1 ? (
                            <FormattedMessage {...messages.reviews} />
                          ) : (
                            <FormattedMessage {...messages.review} />
                          )}
                        </span>
                      </div>
                    )}
                    <div
                      className={cx(s.textLarge, s.colorWhite, s.propertyText)}
                    >
                      <span>{listTitle}</span>
                    </div>
                    <div
                      className={cx(
                        s.textMuted,
                        s.colorWhite,
                        s.listItem
                      )}
                    >
                      <ul className={cx(s.listStyle, "listStyleRTL")}>
                        <li>
                          {listType}
                          {bookingData?.beds > 0 && (
                            <span>
                              <span>&nbsp;-&nbsp;</span>
                              {bookingData?.beds}{" "}
                              {bookingData?.beds > 1
                                ? formatMessage(messages.beds)
                                : formatMessage(messages.bed)}
                            </span>
                          )}
                        </li>
                      </ul>
                      <div className={s.colorWhite}>
                        {" "}
                        {city}, {state}, {country}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <PaymentDetails
                basePrice={basePrice}
                cleaningPrice={cleaningPrice}
                currency={currency}
                taxPrice={taxes}
                discountType={discountType}
                taxValue={tax}
              />
            </div>
            <div className={s.policyCss}>
              <span className={s.checkInText}>
                <FormattedMessage {...messages.cancellationPolicy} />:{" "}
              </span>
              <a
                href={"/cancellation-policies/" + policyName}
                target="_blank"
                className={s.policyColor}
              >
                {policyName}
              </a>
              <div className={cx(s.checkInText)}>{policyContent}</div>
            </div>
          </Col>
        </Row>

        {/* Sticky Footer for Mobile */}
        <div className={s.stickyFooter}>
          <div className={s.stickyFooterContainer}>
            <div className={s.stickyFooterContent}>
              <div className={s.stickyFooterButton}>
                <Button
                  type="submit"
                  form="payment-form"
                  className={cx(s.btn, bt.btnPrimary)}
                  disabled={submitting || maximumStay}
                >
                  <FormattedMessage {...messages.sendBookingRequest} />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}


const mapState = (state) => ({
  stripePayment: state?.book?.stripePayment,
  specialPricing: state?.viewListing?.specialPricing,
  toCurrency: state.currency.to || state.currency.base,
  paymentLoading: state?.book?.paymentLoading,
  maximumStay: state?.viewListing?.maximumStay,
  submitting: state?.form?.PaymentForm?.submitting,
  syncErrors: state?.form?.PaymentForm?.syncErrors,
});

const mapDispatch = {};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(Payment))
);
